export default "__VITE_ASSET__DGR9z8n5__"